module.exports = __webpack_public_path__ + "img/seminar_seminar_body.14a7de42.jpg";